'use strict';

const {
  SHELL_COOKIE_NAME,
  SHELL_FINCH_EXPERIMENT,
  SHELL_GUARD_EXPERIMENT,
} = require('../constants');

module.exports = {
  init() {
    if (
      window.Finch &&
      window.Finch.inTreatment(SHELL_GUARD_EXPERIMENT) &&
      window.Finch.inTreatment(SHELL_FINCH_EXPERIMENT)
    ) {
      // indicate Akamai that user is bucketed
      window.Cookie.set(SHELL_COOKIE_NAME, 'true');
    } else {
      window.Cookie.unset(SHELL_COOKIE_NAME);
    }
  },
};
